import React from "react";

const TILE_IMG = "/delft-tile.png";

export default function DelftTile({ line1, line2, watermark, testId, innerRef }) {
  return (
    <div
      ref={innerRef}
      className="relative aspect-square w-full select-none bg-cover bg-center"
      style={{ backgroundImage: `url(${TILE_IMG})` }}
      data-testid={testId}
    >
      <div className="absolute inset-[18%] flex flex-col items-center justify-center text-center">
        <p className="font-tile text-2xl font-semibold italic leading-tight text-[#1a3a7a] sm:text-[1.7rem]">{line1}</p>
        {line2 && (
          <p className="font-tile mt-2 text-xl font-medium italic leading-tight text-[#2451a6] sm:text-2xl">{line2}</p>
        )}
      </div>
      {watermark && (
        <p className="absolute bottom-[6%] left-0 right-0 text-center text-[7px] font-medium uppercase leading-none tracking-[0.12em] text-[#2451a6]/70 sm:text-[8px]">
          Made with core-emotion.com
        </p>
      )}
    </div>
  );
}
